jQuery(document).ready(function($) {
  $.each($('.p_price'), function(){
    var price = $(this).html();
    $(this).html(price.replace(/(\D*)(\d*\.)(\d*)/,'<span>$1</span><span>$2</span><span class=\'nano\'>$3</span>'));
  });

  // store the slider in a local variable
  var $window = $(window),
      flexslider = { vars:{} };

  // tiny helper function to add breakpoints
  function getGridSize() {
    return (window.innerWidth < 431) ? 1 :
    (window.innerWidth < 600) ? 2 :
    (window.innerWidth < 768) ? 3 :
    (window.innerWidth < 941) ? 4 : 5;
  }

  $('.our_customers_slider').slick({
    infinite: true,
    slidesToShow: 6,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
  });


  $('.carousel').flexslider({
    animation: "slide",
    animationLoop: true,
    minItems: getGridSize(),
    maxItems: getGridSize(),
    slideshow: true,
    itemMargin: 5,
    move: 1,
    itemWidth: 240,
    slideshowSpeed:3000

  });

  $window.resize(function() {
    var gridSize = getGridSize();
    flexslider.vars.minItems = gridSize;
    flexslider.vars.maxItems = gridSize;
  });


  //   Search button With close
  $('.searchBox a').click(function(){
    $('.searchForm .search-box').val('');
    if($('.searchForm').hasClass('active'))
    {
      $('.searchForm').removeClass('active');  
    }
    else
    {
      $('.searchForm').addClass('active');  
    }

    //     	$('.searchForm .search-box').focus();

    return false;
  });


  $('.searchForm').click(function(e){
    e.stopPropagation();
  });

  //   jquery ui tooltip intioalization for Addons
  //   	 Tipped.create('*[title]');

  $(".navigation_bar").click(function(e){
    e.preventDefault();
    console.log('here');
    if($(this).hasClass('active')){
      $(this).next('#mobile_navigation').slideUp();
      $(this).removeClass('active');
    }else{
      $(this).next('#mobile_navigation').slideDown();
      $(this).addClass('active');
    }
  });
  
  $("#mobile_navigation .site-nav--has-dropdown > a").click(function(){
    $(this).parent().toggleClass("dropdown-show").siblings().removeClass("dropdown-show");
  });
  $("#mobile_navigation .has--menulink > a").click(function(e){
    e.stopPropagation();
    $(this).parent().toggleClass("submenu-show").siblings().removeClass("submenu-show");
  });

  $(function () {
    setNavigacija();
  });

  function setNavigacija() {
    var path = window.location.pathname;
    path = path.replace(/\/$/, "");
    path = decodeURIComponent(path);
    $(".site-nav li a").each(function () {
        var href = $(this).attr('href');
        if (path.substring(0, href.length) == href) {
          $(this).closest('li').addClass('active').siblings().removeClass('active');
          $(this).parents('.has--menulink').addClass('active').siblings().removeClass('active');
          $(this).parents('.site-nav li').addClass('active').siblings().removeClass('active');
          $(".has--menulink.active").addClass("submenu-show");
          $(".site-nav--has-dropdown.active").addClass("dropdown-show");
        }
    });
  }
  
  $('.modal-toggle').on('click', function(e) {
    e.preventDefault();
    $('.modal').toggleClass('is-visible');
  });
  
});


$(window).scroll(function() {    
  var scroll = $(window).scrollTop();
  var width =  $(window).width();
  if (scroll >= 900 && width <= 767 ) {
    $(".cart-submit").addClass("sticky-btn");
  } else {
    $(".cart-submit").removeClass("sticky-btn");
  }
});